import categoryService from "app/common/services/categoryService";
import type { ICategory, IFlattenedCategory } from "app/common/services/categoryService.types";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { UserCustomCategoryService } from "app/services/category/userCustomCategoryService";

import { extractPrimaryCategoryFromParams } from "../routes/routeUtils";

const getCategoryByForUrl = (forUrl: string): ICategory | undefined => {
    if (UserCustomCategoryService.isCustomCategory(forUrl)) {
        return UserCustomCategoryService.getCategoryByForUrl(forUrl);
    }
    return categoryService.getCategory(forUrl);
};

export const getSelectedCategory = (): ICategory => {
    const params = proNavigator.getParams();
    const primaryCategory = extractPrimaryCategoryFromParams(params.category);
    const categoryRecord = getCategoryByForUrl(primaryCategory);
    return categoryRecord;
};

export const getFlattenSelectedCategory = (): IFlattenedCategory => {
    const params = proNavigator.getParams();
    const primaryCategory = extractPrimaryCategoryFromParams(params.category);
    const flattenedCategoriesList = categoryService.getFlattenedCategoriesList();
    const flattenedCategory = flattenedCategoriesList.find((item) => item.forUrl === primaryCategory);
    return flattenedCategory;
};

export const isSelectedIndustryCustom = (): boolean => {
    const category = getSelectedCategory();
    return category?.isCustomCategory;
};

export const hasAnySelectedCategoryWithSegments = (): boolean => {
    const params = proNavigator.getParams();
    const categoryParams = Array.isArray(params.category) ? params.category : [params.category];
    return categoryParams.some((categoryParam) => {
        const categoryObject = categoryService.categoryQueryParamToCategoryObject(categoryParam);
        return categoryObject?.segments?.length > 0;
    });
};
